// Action Types
export const FETCH_CHARTS_STARTED = "FETCH_CHARTS_STARTED";
export const FETCH_CHARTS_SUCCESS = "FETCH_CHARTS_SUCCESS";
export const FETCH_CHARTS_ERROR = "FETCH_CHARTS_ERROR";
// Data types
export interface Chart {
    id: number
    title: string,
    nodes: any,
    parent_nodes: number[]
}
export interface ChartNode {
    id: number,
    title: string,
    description: string,
    chart: number,
    parent: number,
    children: number[]
}

//Reducer State Type
export interface ChartsState {
    items: Chart[]
    error: any
    isFetching: boolean
}
// Action Data Types
export interface FetchChartsActionStarted {
    type: typeof FETCH_CHARTS_STARTED
}
export interface FetchChartsActionSuccess {
    type: typeof FETCH_CHARTS_SUCCESS,
    charts: Chart[]
}
export type FetchChartsActionTypes = FetchChartsActionStarted | FetchChartsActionSuccess;